import { OrganizationSettingsPages } from "@components/settings/constants";
import { useSettings } from "@components/settings/SettingsProvider";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";

const FIRM_PROFILE_SETTINGS_PATH = OrganizationSettingsPages.FIRM_INFORMATION;

/** Opens the firm Profile settings, or `undefined` when the user can't manage them. */
export const useOpenFirmSettings = () => {
    const { validPaths, open: openSettings } = useSettings();
    const canManageOrganizationSettings = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );

    if (
        !canManageOrganizationSettings ||
        !validPaths.includes(FIRM_PROFILE_SETTINGS_PATH)
    ) {
        return undefined;
    }

    return () => openSettings([FIRM_PROFILE_SETTINGS_PATH]);
};
